<template>
  <span
    v-if="text"
    v-html="text"
    :class="[
      'rounded p-2',
      theme === 'alert' ? 'bg-error-bg text-error' : '',
      theme === 'warning' ? 'bg-warning-bg text-warning' : '',
      theme === 'success' ? 'bg-success-bg text-success' : '',
      theme === 'info' ? 'bg-info-bg text-info' : '',
    ]"></span>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'InfoText',
  props: {
    text: {
      type: String,
      required: false,
    },
    theme: {
      type: String as PropType<'alert' | 'warning' | 'success' | 'info'>,
      default: 'alert',
    },
  },
}
</script>
